import { ReactSVG } from "react-svg";
import { GifMakao} from "../../assets/images";

export function Loader({ loading }) {
    if (!loading)
        return <></>
    return <div className="loader_container">
        <ReactSVG src={GifMakao} className=" svg_container heartImg" />
    </div>
}